module.exports = __webpack_public_path__ + "static/media/bg-evnt-am-wrp.0e5bdf21.jpg";